<template>
  <ContainerLayoutWrapper v-if="errorStore.error">
    <ContainerError
      :error="errorStore.error"
      :organization="deepAdminUsersMeStore.selectedOrganization"
    />
  </ContainerLayoutWrapper>
  <slot v-else />
</template>

<script lang="ts" setup>
import { useDeepAdminUsersMeStore } from '@/stores/deepadmin/users/users-me'
import { useErrorStore } from '@/stores/error/error'
import ContainerError from '@/components/containers/ContainerError.vue'
import ContainerLayoutWrapper from '@/components/containers/ContainerLayoutWrapper.vue'

const errorStore = useErrorStore()
const deepAdminUsersMeStore = useDeepAdminUsersMeStore()
</script>
